import { render, staticRenderFns } from "./GovernmentProfileFormFields.vue?vue&type=template&id=1c0da0c0&scoped=true&"
import script from "./GovernmentProfileFormFields.vue?vue&type=script&lang=js&"
export * from "./GovernmentProfileFormFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0da0c0",
  null
  
)

export default component.exports